import { createI18n } from 'vue-i18n'

import en from '~/locales/en.json'
import si from '~/locales/si.json'

export default defineNuxtPlugin(({ vueApp }) => {
  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: 'si',
    messages: { en, si }
  })

  vueApp.use(i18n)
})
